import { useEffect, useState, startTransition } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { complexesUrl } from "@/lib/translations";
import { ComplexCard } from "@/components/ComplexCard";

/** Startseiten-Block „Fincas & Anlagen“: beste Anlagen (Bewertung, dann Einheitenzahl) mit Link zur Übersicht. */
export const HomeComplexes = ({ limit = 3 }) => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/complexes").then((r) => startTransition(() => setItems(r.data))).catch(() => setItems([])); }, []);
  const list = [...items].filter((c) => c.hero_image).sort((a, b) => (b.rating_avg || 0) - (a.rating_avg || 0) || (b.reviews_count || 0) - (a.reviews_count || 0) || (b.unit_count || 0) - (a.unit_count || 0)).slice(0, limit);
  if (!list.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 home-section" data-testid="home-complexes">
      <div className="flex items-end justify-between home-section-head gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-brand">{t.complex.homeSubtitle}</div>
          <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mt-3">{t.complex.homeTitle}</h2>
        </div>
        <Link to={complexesUrl()} className="text-sm text-brand underline underline-offset-4 hover:text-brand-hover inline-flex items-center gap-1 whitespace-nowrap" data-testid="home-complexes-all">{t.complex.showAll} →</Link>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {list.map((c) => <ComplexCard key={c.id} complex={c} />)}
      </div>
    </section>
  );
};
